ui-cms-footnote-list {
  display: block;
  font-family: var(--skin-font-family-primary, $font-family-sans-serif);
  position: relative;
}
